// src/services/ezer/EzerPageContext.js
import pageContextData from '@/assets/tools/ezer_ai_page_context.json'
import navigationGuideData from '@/assets/tools/ezer_ai_navigation_guide.json'

const routeMap = pageContextData.routes
const suggestions = pageContextData.suggestions

/**
 * Resolve the current Vue Router path to a page context ID.
 * Uses prefix matching to handle parameterized routes like /users/edit/:id
 */
export function resolvePageContext(routePath) {
  // Exact match first
  if (routeMap[routePath]) return routeMap[routePath]

  // Prefix match (longest first for specificity)
  const sortedKeys = Object.keys(routeMap).sort((a, b) => b.length - a.length)
  for (const key of sortedKeys) {
    if (routePath.startsWith(key)) return routeMap[key]
  }

  return { contextId: 'unknown', label: 'ChurchScheduling' }
}

/**
 * Get suggestions for the current page context.
 */
export function getSuggestions(contextId) {
  return suggestions[contextId] || suggestions._default
}

/**
 * Get the full navigation guide data for the Ezer AI chatbot.
 * Contains all pages, dashboard cards, menu items, and navigation tips
 * organized by section (mainMenu, adminDashboardCards, adminMenuItems,
 * volunteerDashboardCards, volunteerMenuItems, otherPages, navigationTips).
 */
export function getNavigationGuide() {
  return navigationGuideData
}

/**
 * Look up a specific page/section by its ID across all navigation categories.
 * Returns the matching entry or null.
 */
export function findNavigationEntry(id) {
  const allEntries = [
    ...(navigationGuideData.mainMenu || []),
    ...(navigationGuideData.adminDashboardCards || []),
    ...(navigationGuideData.adminMenuItems || []),
    ...(navigationGuideData.volunteerDashboardCards || []),
    ...(navigationGuideData.volunteerMenuItems || []),
    ...(navigationGuideData.otherPages || []),
  ]
  return allEntries.find(entry => entry.id === id) || null
}
